import { apiRequest, meetingRegistrationUpdate, meetingRegistrationDetail } from "../../../../services/adapters/base";

class UpdateRepository {
  fetchUpdate = async (query) => {
    return await apiRequest(
      "post",
      meetingRegistrationUpdate,
      {
        body: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      meetingRegistrationDetail,
      {
        params: query,
      },
      true
    );
  };
}

export default UpdateRepository;
